import React from "react";
import css from "./assessment_card.module.scss";
import DoughnutChart from "re_redesigned_componnents/Graph/Doughnut";
import { IconAssessmentRocket,IconAi } from "re_redesigned_componnents/icon";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import * as config from "../../config";
import { Badge, Chip, useMediaQuery } from "@mui/material";
function AssessmentCard({ data }) {
  const history = useHistory();
  const isLargeScreen = useMediaQuery('(min-width:768px)'); 
  return (
    <div className={css.assessment_wrap}>
      <div className={css.chart}>
        <DoughnutChart donutValues={data}/>
      </div>
      <div className={css.content_wrap}>
        <div className={css.header}>
          {<p>{data.name}</p>}
         <div className={css.icon_wrap}> 
          {data.ai_generated == 1 && <IconAi style={{paddingRight:"5px"}}></IconAi>}
          <Chip
            label={ data?.assessment_status}
            sx={{
              fontSize:"10px",
              padding:".1rem",
              height: "inherit",
              backgroundColor:
                data?.assessment_status === "Yet to Start"
                  ? "#68e968"
                  : "#f7c709", // Fixed color value
              color: "white", // Fixed color property
            }}
          /> </div>
        </div>
        <div className={css.content_topic}>
          <div className={css.content_values}>
            <p>start date : {data.start_date}</p>
            <p>end date : {data.due_date}</p>
          </div>
          <button
            onClick={() => {
              history.push({
                pathname: config.ROUTES.assessmentsLanding, // Replace with your target route
                subjectData: data, // Pass state here
              });
            }}
            className={css.assessment_button}
          >
            <IconAssessmentRocket /> {isLargeScreen && "Start Assessment"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AssessmentCard;
